module.exports = __webpack_public_path__ + "static/media/NEXT.b6e7d63c.png";